import { DeliveryDateProductType, SubscriptionType } from "@/primary-models";

export function subscriptionTypeToDeliveryDateType(
  subscriptionType: SubscriptionType,
): DeliveryDateProductType {
  switch (subscriptionType) {
    case "FRESH":
      return DeliveryDateProductType.FRESH;
    case "SCOOP_HEALTH":
      return DeliveryDateProductType.HEALTH_SCOOP;
    case "SCOOP_PLANET":
      return DeliveryDateProductType.PLANET_SCOOP;
    default: {
      const never: never = subscriptionType;
      throw new Error(`subscriptionTypeToDeliveryDateType: should never happen: Unexpected subscription type '${never}'`);
    }
  }
}
